import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Info from '@material-ui/icons/Info';
import Loading from '../loading/loading';
import moment from "moment";
import {_isAdmin, _isDepartmentUser, scrollToElement} from "../../helpers/functions";
import FloatingActionButton from '../elements/floatingActionButton';
import {TABLE_VIEW_AMOUNTS} from "../../helpers/constants";
import ScoreRecordFileForm from "../scoreRecord/scoreRecordFileForm";
import CustomModal from "../elements/customModal";
import ScoreRecordInfo from '../scoreRecord/scoreRecordInfo';
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import FilterListIcon from "@material-ui/icons/FilterList";
import CloudUpload from '@material-ui/icons/CloudUpload';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import _ from 'lodash';
import ClearAll from '@material-ui/icons/ClearAll';
import ScoreRecordsFilterForm from './scoreRecordsFilterForm';
import MediaQuery from "react-responsive";
import ScoreRecordsListMobileView from './scoreRecordsListMobileView';

class EnhancedTableHead extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, numSelected, rowCount, columnData, personRoles, order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell/>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
              >
                <Tooltip
                  title="Sort"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  spacer: {
    flex: '1 1 auto',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  button: {
    margin: theme.spacing.unit,
  },
  '@media screen and (max-width: 768px)': {
    root: {
      display: 'flex',
      flexDirection: 'column'
    }
  }
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            Score Records
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton aria-label="Delete">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : <div>

          <Button color="secondary" className={classes.button} onClick={props.clearFilters}>
            Clear filters
            <ClearAll  className={'ml-1'}/>
          </Button>
          <Button color="primary" className={classes.button} onClick={props.openScoreRecordsFilterModal}>
            Filter list
            <FilterListIcon className={'ml-1'}/>
          </Button>
          <Button color="primary" className={classes.button} onClick={props.openUploadModal}>
            {'Upload Score'}
            <CloudUpload className={'ml-1'}/>
          </Button>
        </div>}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
  },
  tableWrapper: {
  },
  '@media screen and (max-width: 768px)': {
    pager: {
      paddingBottom: '8% !important',
    },
    pagerToolbar: {
      flexWrap: 'wrap !important',
      justifyContent: 'center !important'
    }
  }
});

class ScoreRecords extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: [],
      order: 'desc',
      orderBy: 'createdDate',
      data: [],
      page: 0,
      rowsPerPage: 100,
      infoModalOpen: false,
      scoreRecordId: null,
      deleteModalOpen: false,
    };

    this.scoreRecordsListRef = React.createRef();

  }

  _openDeleteModal = (scoreRecordId) => {
    this.setState({
      ...this.state,
      deleteModalOpen: true,
      scoreRecordId: scoreRecordId
    });
  };

  _closeDeleteModal = () => {
    this.setState({
      ...this.state,
      deleteModalOpen: false,
      scoreRecordId: null
    });
  };

  _openInfoModal = (scoreRecordId) => {
    this.setState({
      ...this.state,
      infoModalOpen: true,
      scoreRecordId: scoreRecordId
    });
  };

  _closeInfoModal = () => {
    this.setState({
      ...this.state,
      infoModalOpen: false,
      scoreRecordId: null
    });
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.props.scoreRecords.map(n => n.id) });
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  clearFilters = () => {
    //get score records based on user role
    let whereFilter = null;
    if(_isAdmin(this.props.personRoles)){
      whereFilter = {};
    }
    if(_isDepartmentUser(this.props.personRoles)){
      whereFilter = {departmentId: this.props.loggedInPersonDepartmentId};
    }
    this.props.getScoreRecords({
      filter: {
        order:  'createdDate DESC',
        include: [
          {relation: 'person', scope: {include: 'department'}},
          {relation: 'scores', scope: {
              include: ['store', {relation: 'criteria', scope: {include: 'department'}}],
              limit: 1
            }}
        ],
        where: whereFilter
      }
    });
  };

  _changeLocalState = (payload) => {
    this.setState({
      ...this.state,
      [payload.key]: payload.value
    })
  };

  render() {
    const { classes } = this.props;
    const { selected, rowsPerPage, page, order, orderBy } = this.state;
    const data = this.props.scoreRecords;

    const columnData = [
      { id: 'id', numeric: false, disablePadding: false, label: 'Id' },
    ];
    if(_isAdmin(this.props.personRoles)){
      columnData.push(  { id: 'email', numeric: false, disablePadding: false, label: 'Person Email' });
      columnData.push(  { id: 'department', numeric: false, disablePadding: false, label: 'Department' });
      columnData.push(  { id: 'type', numeric: false, disablePadding: false, label: 'Type' });
      columnData.push({ id: 'createdDate', numeric: false, disablePadding: false, label: 'Created Date' })
    } else {
      columnData.push(  { id: 'type', numeric: false, disablePadding: false, label: 'Type' });
      columnData.push({ id: 'createdDate', numeric: false, disablePadding: false, label: 'Created Date' })
    }

    return (
      <div>
        <div >
          <CustomModal
            open={this.props.filterModalOpen}
            handleClose={this.props.closeScoreRecordsFilterModal}
            content={<ScoreRecordsFilterForm {...this.props} handleCancel={this.props.closeScoreRecordsFilterModal}/>}
          />
          <CustomModal
            open={this.state.deleteModalOpen}
            handleClose={this._closeDeleteModal}
            content={<div>
              <Loading displayLoader={this.props.deletingScoreRecord}/>
              <div className={'col-12'}>{'Are you sure you want to delete the selected score record?'}</div>
              <div className={'col-12 mt-3'}>
                <Button
                  onClick={() => this.props.deleteScoreRecord({id: this.state.scoreRecordId})}
                  variant="contained"
                  color="primary"
                  className={'mr-3'}
                >
                  {'Yes'}
                </Button>
                <Button onClick={this._closeDeleteModal} variant="contained" color="secondary">
                  {'No'}
                </Button>
              </div>
            </div>}
          />
          <CustomModal
            open={this.props.uploadModalOpen}
            handleClose={this.props.closeUploadModal}
            content={<div>
              <Loading displayLoader={this.props.postingFile}/>
              <ScoreRecordFileForm {...this.props} handleCancel={this.props.closeUploadModal}/>
            </div>}
          />
        </div>
        <CustomModal
          customStyle={{width: '80%'}}
          open={this.state.infoModalOpen}
          handleClose={this._closeInfoModal}
          content={<div>
            <Loading displayLoader={this.props.fetchingScoreRecord}/>
            <ScoreRecordInfo scoreRecordId={this.state.scoreRecordId}/>
            <Button onClick={this._closeInfoModal} variant="contained" color="secondary" className={'mt-3 custom-modal__btn'}>
              {'Close'}
            </Button>
          </div>}
        />
        <Loading displayLoader={this.props.loading}/>
        <MediaQuery query="(max-device-width: 768px)">
          <ScoreRecordsListMobileView
            {...this.props}
            classes={null}
            clearFilters={this.clearFilters}
            _openInfoModal={this._openInfoModal}
            _closeDeleteModal={this._closeDeleteModal}
            _openDeleteModal={this._openDeleteModal}
            filterScoreRecords={this.filterDepartments}
            openScoreRecordsFilterModal={this.props.openScoreRecordsFilterModal}
            openUploadModal={this.props.openUploadModal}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            page={page}
            _changeLocalState={this._changeLocalState}
            rowsPerPage={rowsPerPage}
          />
        </MediaQuery>
        <MediaQuery query="(min-device-width: 769px)">
          <div ref={this.scoreRecordsListRef}>
            <Paper className={classes.root}>
              <EnhancedTableToolbar
                numSelected={selected.length}
                {...this.props}
                classes={null}
                openScoreRecordsFilterModal={this.props.openScoreRecordsFilterModal}
                clearFilters={this.clearFilters}
              />
              <div className={classes.tableWrapper + ' table-responsive '}>
                <Table className={classes.table + ' table-sm compact'} aria-labelledby="tableTitle">
                  <EnhancedTableHead
                    {...this.props}
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={this.handleSelectAllClick}
                    onRequestSort={this.handleRequestSort}
                    rowCount={data.length}
                    columnData={columnData}
                  />
                  <TableBody>
                    {_.orderBy(data, item => {
                      if(orderBy === 'email' && _isAdmin(this.props.personRoles)) {return item.person.email}
                      return item[orderBy]
                    }, order)
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                        const isSelected = this.isSelected(n.id);
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            aria-checked={isSelected}
                            tabIndex={-1}
                            key={n.id}
                            selected={isSelected}
                          >
                            <TableCell padding="checkbox">
                              <IconButton
                                aria-label="View score record"
                                onClick={() => {
                                  this._openInfoModal(n.id)
                                }}>
                                <Info/>
                              </IconButton>
                              {_isAdmin(this.props.personRoles) && (
                                <IconButton
                                  aria-label="Delete"
                                  onClick={() => this._openDeleteModal(n.id)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              )}
                            </TableCell>
                            <TableCell>
                              {n.id}
                            </TableCell>
                            {_isAdmin(this.props.personRoles) && (
                              <TableCell>
                                {n.person?n.person.email:''}
                              </TableCell>
                            )}
                            {_isAdmin(this.props.personRoles) && (
                              <TableCell>
                                {n.department}
                              </TableCell>
                            )}
                            <TableCell>
                              {n.type}
                            </TableCell>
                            <TableCell>
                              {moment(n.createdDate).format('DD/MM/YYYY HH:mm:ss')}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                classes={
                  {
                    root: classes.pager,
                    toolbar: classes.pagerToolbar
                  }
                }
                rowsPerPageOptions={TABLE_VIEW_AMOUNTS}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                  'aria-label': 'Previous Page',
                }}
                nextIconButtonProps={{
                  'aria-label': 'Next Page',
                }}
                onChangePage={(evt, page) => {
                  scrollToElement(this.scoreRecordsListRef.current);
                  this.handleChangePage(evt, page)
                }}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </MediaQuery>
        { _isDepartmentUser(this.props.personRoles) && (
          <FloatingActionButton onClick={() => this.props.history.push('/score-record')}/>
        )}
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={!!this.props.postingFileMessage}
          onClose={() => {
            this.props.changeScoreRecordState({key: 'postingFileMessage', value: ''});
            this.props.changeScoreRecordState({key: 'postingFileInvalidScores', value: []});
          }}
          ContentProps={{'aria-describedby': 'message-id',}}
          message={
            <span id="message-id">
              {this.props.postingFileMessage}
              {
                this.props.postingFileInvalidScores.length > 0 && (
                  <ul>
                    {
                      this.props.postingFileInvalidScores.map((invalidScore, index) => {
                        return <li key={index}>{invalidScore}</li>
                      })
                    }
                  </ul>
                )}
            </span>
          }
        />
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={!!this.props.deleteScoreRecordMessage}
          onClose={() => { this.props.changeScoreRecordState({key: 'deleteScoreRecordMessage', value: ''}) }}
          ContentProps={{'aria-describedby': 'message-id',}}
          message={<span id="message-id">{this.props.deleteScoreRecordMessage}</span>}
        />
      </div>
    );
  }
}

ScoreRecords.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ScoreRecords);



// WEBPACK FOOTER //
// ./src/components/scoreRecords/scoreRecords.js